// Импортируем все компоненты напрямую
import MDXAdvantagesList from './MDXAdvantagesList';
import CheckList from '../components/blog/CheckList';
import ProductTypes from '../components/blog/ProductTypes';
import ProductCatalog from '../components/blog/ProductCatalog';
import ApplicationAreas from '../components/blog/ApplicationAreas';
import SelectionCriteria from '../components/blog/SelectionCriteria';
import InfoBox from '../components/blog/InfoBox';
import ImageGallery from '../components/blog/ImageGallery.jsx';
import MetalCalculator from '../components/blog/MetalCalculator.jsx';
import ContactForm from '../components/blog/ContactForm.jsx';
import { ComponentPropsWithoutRef } from 'react';
import Link from 'next/link';

// Экспортируем все компоненты напрямую для использования в MDX
const mdxComponents = {
  // Базовые компоненты
  h1: (props: ComponentPropsWithoutRef<"h1">) => (
    <h1 {...props} className="text-3xl text-pale-yellow mt-8 mb-6" />
  ),
  h2: (props: ComponentPropsWithoutRef<"h2">) => (
    <h2 {...props} className="text-2xl text-pale-yellow mt-8 mb-6" />
  ),
  h3: (props: ComponentPropsWithoutRef<"h3">) => (
    <h3 {...props} className="text-xl text-pale-yellow mt-8 mb-6" />
  ),
  h4: (props: ComponentPropsWithoutRef<"h4">) => (
    <h4 {...props} className="text-lg text-pale-yellow mt-8 mb-6" />
  ),
  p: (props: ComponentPropsWithoutRef<"p">) => (
    <p {...props} className="my-4 font-light [&>code]:text-pale-green" />
  ),
  a: (props: ComponentPropsWithoutRef<"a">) => (
    <span>
      {props.href ? (
        <Link
          href={props.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text-pale-blue font-medium" {...props} />
        </Link>
      ) : (
        <a {...props} className="text-pale-blue font-medium" />
      )}
    </span>
  ),
  li: (props: ComponentPropsWithoutRef<"li">) => (
    <li {...props} className="my-2 font-light" />
  ),
  ol: (props: ComponentPropsWithoutRef<"ol">) => (
    <ol {...props} className="my-3 list-decimal list-inside" />
  ),
  ul: (props: ComponentPropsWithoutRef<"ul">) => (
    <ul {...props} className="my-3 list-disc list-inside" />
  ),
  blockquote: (props: ComponentPropsWithoutRef<"blockquote">) => (
    <blockquote className="pl-4 italic border-l-4 border-pale-yellow" {...props} />
  ),

  // Кастомные компоненты блога
  AdvantagesList: MDXAdvantagesList,
  CheckList,
  ProductTypes,
  ProductCatalog,
  ApplicationAreas,
  SelectionCriteria,
  InfoBox,
  ImageGallery,
  MetalCalculator,
  ContactForm,
};

export default mdxComponents; 